<template>
	<div class="focus:wf-outline-none wf-flex wf-items-center wf-justify-center wf-mb-24 wf-bottom-0 wf-cursor-pointer wf-h-12 hover:wf-bg-blue-700 hover:wf-shadow-lg wf-rounded-r-lg wf-shadow wf-w-12 wf-absolute" style="right: -48px;">
		<button
			class="focus:wf-outline-none wf-h-12 wf-w-12 wf-rounded-tr-md hover:wf-shadow-md"
			:class="! previewMode ? 'wf-bg-gray-300 wf-text-gray-600 hover:wf-text-white hover:wf-bg-indigo-300' : 'wf-bg-indigo-600 wf-text-white hover:wf-bg-indigo-500'"
			@click.prevent="togglePreviewMode"
		><i class="fas fa-eye"></i></button>
	</div>
</template>

<script>
	export default {
		computed: {
			previewMode() {
				return this.$store.state.previewMode
			}
		},
		methods: {
			togglePreviewMode() {
				this.$store.commit('togglePreviewMode')
			}
		}
	}
</script>